import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class ModelsChangeService {

  locationValue = new EventEmitter<number>();  
  constructor() { }

}



// WEBPACK FOOTER //
// C:/unnati/backup/latestWebCode29march/backup17-june-20/src/app/models-change.service.ts